export const STRUC_BULK_CREATE_STRUC_LIST_START = 'STRUC_BULK_CREATE_STRUC_LIST_START';
export const STRUC_BULK_CREATE_STRUC_LIST_SUCCESS = 'STRUC_BULK_CREATE_STRUC_LIST_SUCCESS';
export const STRUC_BULK_CREATE_STRUC_LIST_FAIL = 'STRUC_BULK_CREATE_STRUC_LIST_FAIL';
export const STRUC_BULK_CREATE_EXISTING_START = 'STRUC_BULK_CREATE_EXISTING_START';
export const STRUC_BULK_CREATE_EXISTING_SUCCESS = 'STRUC_BULK_CREATE_EXISTING_SUCCESS';
export const STRUC_BULK_CREATE_EXISTING_FAIL = 'STRUC_BULK_CREATE_EXISTING_FAIL';
export const STRUC_BULK_CREATE_STRUC_LIST_RESET = 'STRUC_BULK_CREATE_STRUC_LIST_RESET';
export const STRUC_BULK_CREATE_SET_GRID_STORE = 'STRUC_BULK_CREATE_SET_GRID_STORE';

import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export function setStrucBulkCreateGridStore(gridStore) {
  return { type: STRUC_BULK_CREATE_SET_GRID_STORE, gridStore };
}

export function getStructureList(currency) {
  const errorMessage = 'Could not retrieve a list of structures.';
  return async dispatch => {
    dispatch({ type: STRUC_BULK_CREATE_STRUC_LIST_START });
    try {
      const strucResults = await apiClient.apiGet(
        '/api/structure-modeling/structures/getStructures',
        currency
          ? {
              params: {
                currency
              }
            }
          : {}
      );
      if (strucResults.status !== 200) {
        dispatch({ type: STRUC_BULK_CREATE_STRUC_LIST_FAIL });
      } else {
        dispatch({ type: STRUC_BULK_CREATE_STRUC_LIST_SUCCESS, structures: strucResults.data.structures });
      }
    } catch (e) {
      addAlert(errorMessage, 'danger');
      dispatch({ type: STRUC_BULK_CREATE_STRUC_LIST_FAIL });
      throw e;
    }
  };
}

export function createBulkModelsFromExisting(
  structureCodes,
  joinPosition,
  joinText,
  description,
  publishTo,
  adjustment,
  groups
) {
  return async dispatch => {
    let newJoinText = joinText;
    if (newJoinText === '') {
      if (joinPosition === 'after') {
        newJoinText = 'Model';
      } else {
        newJoinText = 'Model of';
      }
    }
    const cleanDescription = description.replaceAll('\n', '\\n');
    const structures = structureCodes.map(structure => {
      const strucCode = structure.value ? structure.value.code : structure.code;
      const strucCurrency = structure.value ? structure.value.currency : structure.currency;
      return {
        code: strucCode,
        currency: strucCurrency,
        joinPosition,
        joinText: newJoinText,
        description: cleanDescription,
        publishTo,
        groups: groups.map(group => (Number.isInteger(group) ? group : parseInt(group.value)))
      };
    });

    dispatch({ type: STRUC_BULK_CREATE_EXISTING_START });
    try {
      const createBody = {
        structures
      };
      if (adjustment) createBody.adjustment = adjustment;
      const createResults = await apiClient.apiPost(
        '/api/structure-modeling/create/createModelsFromStructures',
        createBody
      );
      if (createResults.status !== 200) {
        dispatch({ type: STRUC_BULK_CREATE_EXISTING_FAIL });
      } else {
        dispatch({ type: STRUC_BULK_CREATE_EXISTING_SUCCESS });
      }
    } catch (e) {
      dispatch({ type: STRUC_BULK_CREATE_EXISTING_FAIL });
      throw e;
    }
  };
}

export function resetBulkCreateReducer(resetAll) {
  return { type: STRUC_BULK_CREATE_STRUC_LIST_RESET, resetAll };
}
